
import CategorySelector from './components/category_selector';

import useTranslations from "../providers/useTranslations";
import { CartContext } from '../providers/CartContext';
import { BusinessContext } from '../providers/BusinessContext';
import CategoryListItem from './components/common/category_list_item';
import CategoryView from './Category'
import Header from './components/common/Header';

import ProductView from './ProductView'
import ServiceView from './ServiceView'
import CartView from './CartView'
import ProductListItem from './components/common/product_list_item'

import { prefixedColour, padZero, invertColor, styleFromColour, addStyleElement } from './utils'
const jquery = window.jQuery

const Detail = (props) => {

  const { business, local, menu, setStage } = props

  const { cartItems, addItemToCart, clearCart, setItemQuantity, removeItem, pendingOrder, totalItemsCost } = React.useContext(CartContext);

  const { checkMenuPeriods, locationConfigBool, subscriptionLevel } = React.useContext(BusinessContext);

  const pricingSection = React.useRef(null);
  //const { config, getConfig } =React.useContext(ConfigContext);
  const { tr, trmap, getTranslations /* , , locale, translations, setLocale */ } = useTranslations();
  const [selectedMenu, setSelectedMenu] = React.useState(null)
  const [selectedCategory, setSelectedCategory] = React.useState(null)
  const [selectedProduct, setSelectedProduct] = React.useState(null)
  const [selectedService, setSelectedService] = React.useState(null)
  const [ordersAvailable, setOrdersAvailable] = React.useState(false)
  const [hasOrdering, setHasOrdering] = React.useState(true)
  const [optionsFirst, setOptionsFirst] = React.useState(false)
  const [openCart, setOpenCart] = React.useState(false)

  const [currentCategory, setCurrentCategory] = React.useState(null)
  const [hideZero, setHideZero] = React.useState(false)
  const [collapsedCategories, setCollapsedCategories] = React.useState(false)
  const [searchTerm, setSearchTerm] = React.useState(null)
  const [productList, setProductList] = React.useState([])

  const [breadcrumbs, setBreadcrumbs] = React.useState([])
  const [categoriesMap, setCategoriesMap] = React.useState([])
  const [hasSubCategories, setHasSubCategories] = React.useState(false)
  const [initialised, setInitialised] = React.useState(false)

  const checkmenu = (menu, hasCredit, business) => {
    if (business && business.type == "Gastronomy") {
      let openPeriod = checkMenuPeriods(menu, business)

      setOrdersAvailable(hasCredit && openPeriod.isOpen)
    } else {
      setOrdersAvailable(true)
    }

  }

  const _getOptions = (menu, business) => {
    let oba = locationConfigBool(business.Configs, menu.Location.id, "optionsBeforeAddons", false)
    //console.log("oba", oba)
    setOptionsFirst(oba)

    let hzp = locationConfigBool(business.Configs, menu.Location.id, "hideZeroProducts", false)
    setHideZero(hzp)

    let clcats = locationConfigBool(business.Configs, menu.Location.id, "collapsedCategories", true)
    setCollapsedCategories(clcats)

  }

  const flattenCategories = (categories) => {
    // convert a nested tree of categories into an array
    let cats = []
    categories.forEach((cat) => {
      cats.push(cat)
      if (cat.Categories && cat.Categories.length > 0) {
        cats = cats.concat(flattenCategories(cat.Categories))
      }
    })
    return cats
  }

  const _showMenu = (business, hasCredit, menu) => {

    // flatten a nested array of categories into an array
    let cats = flattenCategories(menu.Category.Categories)
    //console.log("flatten", cats)

    // create the categories map
    let cmap = new Map()
    cats.forEach((cat) => {
      cmap.set(cat.id, cat)
    })

    // add the initial category
    cmap.set(menu.Category.id, menu.Category)

    //console.log("setCategoriesMap", cmap)

    // determine if there are nested categories
    // we only need to check 1 level deep
    let hasSubs = false
    menu.Category.Categories.forEach((cat) => {
      if (cat.Categories != null && cat.Categories.length > 0) {
        hasSubs = true
      }
    })

    setHasSubCategories(hasSubs)

    setCategoriesMap(cmap)

    setSelectedMenu(menu)

    checkmenu(menu, hasCredit, business)

    _getOptions(menu, business)

    //console.log("_showMenu with", business, menu)
  }

  React.useEffect(() => {
    //console.log("useEffect cartItems", cartItems)

    if (props.menu && props.business) {
      //console.log("show menu", props.business, props.menu)
      if (selectedMenu != props.menu && initialised === false) {
        addStyleElement(props.business, props.menu)
        _showMenu(props.business, true, props.menu)
      }

    } else {
      window.location.href = "/"
    }

    if (initialised === false) {
      window.addEventListener("beforeunload", (event) => {
        event.preventDefault();

        // Google Chrome requires returnValue to be set.
        event.returnValue = '';

      });

      getTranslations()
      setInitialised(true)
    }

    if (window.menu) {
      //console.log("clear cart", window.menu, menu.Location)
      clearCart(window.menu, cartItems)
    }

  }, [cartItems]);  // pendingOrder, cartItems

  React.useEffect(() => {
    //console.log("Detail carouselImages useEffect")
    // initiate Owl carousel
    if (carouselImages != null) {
      $(".owl-carousel").owlCarousel(
        {
          responsive: {
            0: {
              items: 1,
            },
            600: {
              items: 1,
            },
            1000: {
              items: 2,
            },
            1200: {
              items: 3,
            },
          },
          items: carouselImages.length,
          lazyLoad: true,
          pagination: "false",
          loop: true,
          center: true,
          dots: true,
          loop: true,
          //margin: 10,
          autoplay: true,
          autoplayTimeout: 3000,
          autoplayHoverPause: true,
          nav: false,
          navText: ["<i class='icofont-thin-left'></i>", "<i class='icofont-thin-right'></i>"]
        }

      );
    }
  },);

  function _getOffer() {
    if (selectedMenu && selectedMenu.Offers && selectedMenu.Offers.length > 0) {
      let offer = selectedMenu.Offers.find(offer => offer.isActive === true);

      return (
        <div className="bg-white rounded shadow-sm text-white mb-4 p-4 clearfix restaurant-detailed-earn-pts card-icon-overlap">
          <img fluid className="float-left mr-3" src="/img/earn-score-icon.png" />
          <h6 className="pt-0 text-primary mb-1 font-weight-bold">{tr('OFFER')}</h6>
          <p className="mb-0">{offer.name}<span className="text-danger font-weight-bold">{offer.saving}</span></p>
          <div className="icon-overlap">
            <i className="icofont-sale-discount" />
          </div>
        </div>
      )
    }
  }

  //console.log("Detail selectedMenu", selectedMenu)

  const getHeader = (menuData) => {

    return assetsRow(menuData.Business, menuData)

  }

  const assetsRow = (business, menu) => {

    if (window.carouselImages && window.carouselImages.length > 0) {
      return (
        <div className=" carouselImages-carousel">
          <div className=" centered">
            <div className="owl-carousel owl-theme owl-carousel-five offers-interested-carousel">
              {window.carouselImages.map((url, index) => {
                return (
                  <div className="item" key={`carouselImg_${index}`}>
                    <img src={url} style={{
                      maxHeight: 200,
                      minHeight: 200,
                      maxWidth: 500,
                    }} />
                  </div>
                )
              })

              }

            </div>
          </div>
        </div>
      )

    } else if (business.Assets && business.Assets.length > 1) {
      // return a carousel with the assets
      return (
        <div className=" business-assets-carousel">
          <div className=" centered">
            <div className="owl-carousel owl-theme owl-carousel-five offers-interested-carousel">
              {business.Assets.map((a, index) => {
                return (
                  <div className="item" key={`carouselImg_${index}`}>
                    <img src={a.url} style={{
                      maxHeight: 200,
                      minHeight: 200,
                      maxWidth: 600,
                    }} />
                  </div>
                )
              })

              }

            </div>
          </div>
        </div>
      )
    }

    // get random 5 products with photos
    let photos = []

    menu.Category.Categories.forEach((cat) => {
      if (cat.Products && cat.Products.length > 0) {
        let prods = cat.Products.filter((p) => p.photo != "" && p.photo != business.photo)
        if (prods.length > 0) {
          photos.push(prods.map((p) => p.photo))
        }
      }
      if (cat.Services && cat.Services.length > 0) {
        let prods = cat.Services.filter((p) => p.photo != "" && p.photo != business.photo)
        if (prods.length > 0) {
          photos.push(prods.map((p) => p.photo))
        }
      }
    })

    photos = photos.flat()

    if (photos.length > 10) {
      photos = photos.slice(0, 10)
    }
    //console.log("products", products)

    if (photos.length > 0) {
      // return the asset image
      return (
        <div className="row product-carousel">
          <div className="col-12 centered">
            <div className="owl-carousel owl-theme owl-carousel-five offers-interested-carousel">
              {photos.map((a, index) => {
                return (
                  <div className="item" key={`carouselImg_${index}`}>
                    <img src={a.photo} style={{
                      maxHeight: 200,
                      minHeight: 200,
                      maxWidth: 600,
                      //objectFit: 'cover'
                    }} />
                  </div>
                )
              })

              }

            </div>
          </div>
        </div>
      )
    } else if (business.banner && business.banner != "") {
      // return the business banner
      return (
        <div className="row business-banner-row">
          <div className="col centered"><img src={business.banner} style={{
            maxHeight: 200,
            minHeight: 100,
            maxWidth: 400,
            objectFit: 'cover'
          }} /></div>
        </div>
      )
    }

    return <></>

  }

  if (!selectedMenu) {
    return <></>
  }

  //console.log("render with", selectedMenu)
  let shareURL = {
    title: selectedMenu.Business.Name,
    text: 'Visita este enlace para grandes ofertas',
    url: `https://zono.cc?bid=${selectedMenu.business_id}&lid=${selectedMenu.location_id}&mid=${selectedMenu.id} `
  };

  let categories = selectedMenu.Category.Categories.filter((c) => c.enabled === true).sort((a, b) => a.sequence - b.sequence)

  function ContentPanel(props) {

    return <div className="content-panel">
      <section className="offer-dedicated-nav bg-white border-top-0 shadow-sm">

      </section>
      <section className="offer-dedicated-body py-2 mb-4">
        <div>
          <div className=" px-0" >
            <div className="offer-dedicated-body-left">
              <div className='h-100 tab-content'>
                <div role="tabpanel" aria-hidden="false" className="fade tab-pane active show">

                  {(hasOrdering === false || ordersAvailable === false) &&
                    <div className="row" style={{ margin: 5 }}>
                      <div className="col-md-12" >
                        <h5>
                          {tr("This business cannot take orders at the moment, please check back later")}
                        </h5>
                      </div>
                    </div>

                  }
                  {props.children}

                </div>

              </div>
            </div>
          </div>

        </div>
      </section>

    </div>
  }

  const _productIsOffer = (product) => {
    // if the product id is in an offer in the location
    if (!selectedMenu || selectedMenu.Location == null || selectedMenu.Location.Campaigns == null) {
      return false
    }
    let found = selectedMenu.Location.Campaigns.find((offer) => offer.productId == product.id)

    return found
  }

  //console.log("detail with menu", selectedMenu, selectedCategory, currentCategory, collapsedCategories)

  const isVisible = (p) => {

    if (hideZero && p.managed === true && p.quantity <= 0) {
      // product inventory is managed
      return false
    }

    return p.available === true //&& p.restricted != true
  }

  const setChosenCategory = (category) => {

    let bcrumbs = [category]
    let cat = category

    while (cat.category_id > 0) {
      // get the parent category from the map
      cat = categoriesMap.get(cat.category_id)
      // prepend to the breadcrumbs
      if (cat.category_id > 0) bcrumbs.unshift(cat)
    }

    //console.log("setChosenCategory", category, bcrumbs)

    // walk up the category tree to find the parent with 0 category_id
    // to rebuild the breadcrumbs
    setBreadcrumbs(bcrumbs)

    setSelectedCategory(category)
  }

  //console.log("selectedCategory", hasSubCategories, selectedCategory)

  const _getContent = () => {

    // console.log("_getContent", openCart, productList.length)
    //console.log("_getContent selectedProduct", selectedProduct)
    // console.log("_getContent selectedCategory", selectedCategory)


    if (openCart) {
      return <CartView closeCart={() => {
        setOpenCart(false)
      }}

        selectedMenu={selectedMenu}

        setStage={setStage}

      />
    }

    else if (selectedService) {
      let isOffer = _productIsOffer(selectedService)
      //console.log("selectedService", selectedService, isOffer)
      return (
        <ContentPanel>
          {searchBarRow(selectedMenu.Location)}
          <ServiceView
            addItemToCart={addItemToCart}
            categories={categories}
            service={selectedService}
            isOffer={isOffer}

            optionsFirst={optionsFirst}
            removeItem={removeItem}
            setItemQuantity={setItemQuantity}
            selectedMenu={selectedMenu}
            business={selectedMenu.Business}
            setSelectedService={(value) => {
              //console.log("setSelectedService ", value)
              setSelectedService(value)
            }}

          />
        </ContentPanel>
      )
    }

    else if (selectedProduct) {
      let isOffer = _productIsOffer(selectedProduct)
      //console.log("selectedProduct", selectedProduct, isOffer)
      return (
        <ContentPanel>
          {searchBarRow(selectedMenu.Location)}
          <ProductView
            addItemToCart={addItemToCart}
            categories={categories}
            product={selectedProduct}
            isOffer={isOffer}

            optionsFirst={optionsFirst}
            removeItem={removeItem}
            setItemQuantity={setItemQuantity}
            selectedMenu={selectedMenu}
            business={selectedMenu.Business}
            setSelectedProduct={(value) => {
              //console.log("setSelectedProduct ", value)
              setSelectedProduct(value)
            }}

          />
        </ContentPanel>
      )
    }

    // productsList is populated by a search
    else if (productList.length > 0) {
      // show a list of products

      return (
        <ContentPanel>
          {searchBarRow(selectedMenu.Location)}

          <div id="product-list-from-search"
            className="category-content shadow-sm mb-1 px-1 centered">

            <div
              className="product-item-grid"
            >

              {productList.filter((p) => isVisible(p)).map((product, i) => {
                let isOffer = _productIsOffer(product)

                let image = product.photo
                if (image == null || image == "") {
                  image = business.photo
                }

                return (<ProductListItem
                  key={i}
                  product={product}
                  categories={categories}
                  id={product.id}
                  image={image}
                  title={product.name}
                  price={product.price}
                  hasOrdering={true}
                  priceUnit='$'
                  isOffer={isOffer}
                  getValue={(args) => {
                    //console.log("getValue add to cart", product.id, args);
                    if (args.quantity === 1) {
                      // make a copy of the object
                      let newItem = Object.assign({}, product);
                      newItem.quantity = 1
                      newItem.menu_id = product.menu_id || selectedMenu.id
                      addItemToCart(newItem, args);
                    } else if (args.quantity === 0) {
                      removeItem(product, args);
                    } else {
                      setItemQuantity(product, args.quantity);
                    }

                  }}
                  setSelectedProduct={(value) => {
                    //console.log("setSelectedProduct ", value)
                    setSelectedProduct(value)

                  }}
                  detailColour={'#F1AD3E'}
                  optionsFirst={optionsFirst}
                />)
              })}

            </div>



          </div>

        </ContentPanel>

      )
    }

    else if (selectedCategory) {
      // display the category contents

      // console.log("display category", selectedCategory.name)
      // console.log("categories ", categories)
      return (
        <ContentPanel>
          {searchBarRow(selectedMenu.Location)}

          {hasSubCategories &&
            <CategorySelector categories={categories}
              menu={selectedMenu}
              onSelected={(category) => {
                setChosenCategory(category)
              }} />
          }

          {breadcrumbs.length > 0 &&

            <div className="category-breadcrumbs">
              <span className="breadcrumb-link" onClick={() => {
                setSelectedCategory(null)
                setBreadcrumbs([])
              }} >Inicio</span>
              {breadcrumbs.map((cat, index) => {
                if (cat.id == selectedCategory.id) {
                  return <span className="breadcrumb-opaque" key={`breadcrumb_${cat.id}`}> &gt; {cat.name}</span>
                }

                return <span className="breadcrumb-link" key={`breadcrumb_${cat.id}`} onClick={() => {
                  setChosenCategory(cat)
                }}> &gt; {cat.name}</span>
              })}
            </div>
          }

          <CategoryView
            addItemToCart={addItemToCart}
            category={selectedCategory} index={1}
            categories={categories}
            hideZero={hideZero}
            isCollapsed={false}
            isSelected={true}
            optionsFirst={optionsFirst}
            removeItem={removeItem}
            setItemQuantity={setItemQuantity}
            selectedMenu={selectedMenu}
            business={selectedMenu.Business}
            setSelectedCategory={(value) => {
              //console.log("set category to ", value)
              setChosenCategory(value)
            }}
            setSelectedProduct={setSelectedProduct}
            setSelectedService={setSelectedService}
            pushCategory={pushCategory}
            popCategory={popCategory}
            searchTerm={searchTerm}
          />
        </ContentPanel>

      )
    }

    // display the menu categories
    return <div>
      {getHeader(selectedMenu)}
      {searchBarRow(selectedMenu.Location)}

      <ContentPanel>

        {hasSubCategories &&
          <CategorySelector categories={categories}
            menu={selectedMenu}
            onSelected={(category) => {
              setChosenCategory(category)
            }} />
        }

        {categories.map((category, index) => {
          // this only displays the category header unless isCollapsed is false
          // in that case it also displays the category products
          return (
            <CategoryListItem
              key={`category_${category.name}`}
              addItemToCart={addItemToCart}
              category={category} index={index}
              categories={categories}
              hideZero={hideZero}
              isCollapsed={collapsedCategories}
              isSelected={currentCategory && currentCategory.id == category.id}
              optionsFirst={optionsFirst}
              removeItem={removeItem}
              setItemQuantity={setItemQuantity}
              selectedMenu={selectedMenu}
              business={selectedMenu.Business}
              setSelectedCategory={setChosenCategory}
              pushCategory={pushCategory}
            />
          )

        })

        }

      </ContentPanel>
    </div>
  }

  const doSearch = (term) => {

    //console.log("search", term)

    if (!term || term.length < 3) {

      if (productList.length > 0) {
        //console.log("resetting product list", productList.length)
        // reset the product list to empty list
        setProductList([])
        setSearchTerm(term)
      }

      return
    }

    term = term.toLowerCase()

    setSearchTerm(term)

    console.log("searching for", term)

    // if a category is selected search the category
    if (selectedCategory) {
      let products = selectedCategory.Products.filter((p) => matchesterm(p, term))

      console.log("set matching products", products)
      setFoundProducts(products)

    } else {
      // otherwise find the products that match and go to a product list page
      searchProducts(term)
    }

  }

  const setFoundProducts = (list) => {


    setProductList(list)
    // console.log("setFoundProducts", list)
    // focus in the search term field

    console.log("setFoundProducts", list)

    setTimeout(() => {
      const $ = jquery;
      $("#search_input_box").trigger("focus")
    }, 100)

  }

  const matchesterm = (product, term) => {
    return product.name.toLowerCase().includes(term) || product.description.toLowerCase().includes(term)
  }

  const searchProducts = (term) => {
    // search all categories for products with matching name or description
    if (term && term.length > 2) {
      let list = []

      categories.forEach((category, index) => {
        let products = category.Products.filter((p) => matchesterm(p, term))
        list = list.concat(products)
      })
      console.log("searchProducts result", list)

      setFoundProducts(list)

    }
  }

  const searchBarRow = (location) => {
    let phone = location.phone
    if (phone && phone.startsWith('+')) phone = phone.slice(1)

    let mapsUrl = `https://maps.google.com/?ll=${encodeURIComponent(location.latlng)}`
    let whatsappUrl = `https://wa.me/${phone}`
    let callUrl = `tel:${location.phone}`

    return <div className="search_bar_row">
      <a href={mapsUrl} target="_blank" className="social-button">
        <i className='fa fa-map-marker fa-2x' style={{
          paddingLeft: 5,
          verticalAlign: 'bottom',

        }}
        ></i>
      </a>

      <a href={whatsappUrl} target="_blank" className="social-button">
        <i className="icofont icofont-whatsapp icofont-3x" style={{
          paddingLeft: 5,
          verticalAlign: 'bottom',
          fontSize: 28

        }}></i>
      </a>

      <a href={callUrl} target="_blank" className="social-button">

        <i className='fa fa-phone fa-2x' style={{
          paddingLeft: 5,
          verticalAlign: 'bottom',

        }}

        ></i>

      </a>


      {searchBar()}

    </div>
  }

  const searchBar = () => {

    const $ = jquery;

    const _searchIcon = () => {
      if (productList.length > 0) {
        return <i className='fa fa-close ' style={{
          paddingLeft: 5,
          verticalAlign: 'bottom',
          fontSize: 20

        }}
          onClick={() => {
            doSearch("")
            $("#search_input_box").val("")
          }}

        ></i>
      }
      return <i className='fa fa-search ' style={{
        paddingLeft: 5,
        verticalAlign: 'bottom',
        fontSize: 20

      }}

      ></i>
    }

    if (searchTerm == null || searchTerm == "") {
      //console.log("search bar with no term")
      return (

        <div className="search_bar_element">

          <input name="search box"
            id="search_input_box"
            size="10"
            defaultValue={searchTerm}
            tabIndex="0"

            onChange={(evt) => {
              doSearch(evt.target.value)
            }}

          />

          {_searchIcon()}

        </div>
      )
    }

    console.log("search bar with term", searchTerm)

    return (

      <div className="search_bar_element">

        <input name="search box"
          id="search_input_box"
          size="10"
          defaultValue={searchTerm}
          tabIndex="0"
          autofocus="true"

          onChange={(evt) => {
            doSearch(evt.target.value)
          }}

        />

        {_searchIcon()}

      </div>
    )
  }

  const pushCategory = (category) => {
    setBreadcrumbs([...breadcrumbs, category])
    setSelectedCategory(category)
  }

  const popCategory = () => {

    if (breadcrumbs.length < 2) {
      //console.log("popCategory < 2", selectedCategory, breadcrumbs )
      setSelectedCategory(null)
      setBreadcrumbs([])
    } else {
      // go back to the penultimate category
      let bcrumbs = breadcrumbs.slice()
      // remove the last category
      bcrumbs.pop()
      let category = bcrumbs[bcrumbs.length - 1]

      //console.log("popCategory", category, breadcrumbs )
      setBreadcrumbs(bcrumbs)
      setSelectedCategory(category)
    }
  }

  //console.log("Detail with menu", selectedMenu, local )

  return (
    <div className="menu-detail-container" >

      <Header business={selectedMenu.Business} menu={selectedMenu}

        selectedCategory={selectedCategory}
        setSelectedCategory={setChosenCategory}

        toggleCart={() => {
          setOpenCart(!openCart)
        }}

        itemsInCart={cartItems}

        showHistory={() => {
          setStage("history")
        }}

      />

      <div >
        {_getContent()}

      </div>

    </div>
  );

}


export default Detail;

